export class CertificateOfStaff {
    id : number;
    diplomaId: number;
    diplomaName : string;
    disCertificateOfStaffName : string;
    disCertificateOfStaffCourse : string;
    studyTime : string;
    note: string;
    staffId: number;
}